
<div *ngIf="isHelpPanelOpened" class="notification-panel-container d-flex flex-column notification-container" style="overflow-y: auto;">
    <div>
        <button class="close-btn" (click)='this.closePanel($event)'>
            <fa-icon [icon]='faTimes'></fa-icon>
          </button>
      <h2>Help</h2>


      <div class="mb-5">
        <ul class="list-unstyled px-4 mt-3">
            <li class="mb-2">
                <a class="text-decoration-none link-opacity-100-hover"  href="javascript:void(0)"  (click)="openOrFocusWindow(links?.link_getting_started_with_cloud)">Getting Started with NCache Cloud</a>
            </li>
            <li class="mb-2">
                <a  class="text-decoration-none"   href="javascript:void(0)"  (click)="openOrFocusWindow(links?.link_cloud_admin_guide)">NCache Cloud Guide</a>
            </li>
            <li class="mb-2">
                <a class="text-decoration-none"  href="javascript:void(0)" (click)="openOrFocusWindow('https://www.alachisoft.com/resources/docs/ncache/admin-guide/')" >Admin Guide</a>
            </li>
            <li class="mb-2">
                <a class="text-decoration-none"  href="javascript:void(0)"   (click)="openOrFocusWindow(links?.link_programmers_guide)">Programmer's Guide</a>
            </li>
            <li class="mb-2">
                <a class="text-decoration-none" href="javascript:void(0)" (click)="openOrFocusWindow('https://github.com/Alachisoft/NCache-Samples/archive/master.zip')">Download Samples (GitHub)</a>
            </li>
        </ul>
      </div>

      <div class="mb-3 ps-3">
        <p>
          <span class="fw-semibold">Need more help?</span>
          Visit the help and support center to create and manage support requests and support plans.
        </p>
        <a class="btn btn-link p-2 mb-2 rounded-1"
           [attr.href]="links?.link_help_and_support"
           target="_blank"
           id="SupportLinkButton">
          Help &amp; Support
        </a>

        <p><span class="fw-semibold">How to guide user to client SDKs?</span></p>
      <ul class="list-unstyled px-4 mt-3">
        <li class="mb-2">
            <a class="text-decoration-none fw-normal"  href="javascript:void(0)"   (click)="openOrFocusWindow(links?.link_dotnet_guide)">.NET</a>
        </li>
        <li class="mb-2">
            <a  class="text-decoration-none"  href="javascript:void(0)"   (click)="openOrFocusWindow(links?.link_java_guide)">Java</a>
        </li>
        <li class="mb-2">
            <a class="text-decoration-none"  href="javascript:void(0)"   (click)="openOrFocusWindow(links?.link_python_guide)">Python</a>
        </li>
        <li class="mb-2">
            <a class="text-decoration-none" href="javascript:void(0)"   (click)="openOrFocusWindow(links?.link_nodejs_guide)">Node.js</a>
        </li>
    </ul>
</div>

    </div>


  </div>
